import * as io from 'io-ts';

export type GetFraudAlloyRequest = io.TypeOf<typeof GetFraudAlloyRequest>;
export const GetFraudAlloyRequest = io.type({});

export type GetFraudAlloyResponse = io.TypeOf<typeof GetFraudAlloyResponse>;
export const GetFraudAlloyResponse = io.intersection([
  io.type({
    journey_token: io.string,
    journey_application_token: io.string,
    journey_sdk_key: io.string,
  }),
  io.partial({
    origin: io.string,
  }),
]);

export type FraudAlloyInitResponse = io.TypeOf<typeof FraudAlloyInitResponse>;
export const FraudAlloyInitResponse = io.type({
  neuroIdSiteId: io.string,
  neuroUserId: io.string,
  iovationBlackboxId: io.string,
});

export type IDUploadJourneyResponse = io.TypeOf<typeof IDUploadJourneyResponse>;
export const IDUploadJourneyResponse = io.type({
  journey_application_status: io.string,
});

export enum JourneyApplicationStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  Pending = 'Pending',
  Expired = 'Expired',
  ApplicationReview = 'Application Review',
  Error = 'Error',
  Running = 'Running',
}

export const FraudJourneyApplicationStatusKYCResponse = io.type({
  journey_application_status: io.union([
    io.literal(JourneyApplicationStatus.Approved),
    io.literal(JourneyApplicationStatus.Denied),
    io.literal(JourneyApplicationStatus.Pending),
    io.literal(JourneyApplicationStatus.Expired),
    io.literal(JourneyApplicationStatus.ApplicationReview),
    io.literal(JourneyApplicationStatus.Error),
    io.literal(JourneyApplicationStatus.Running),
  ]),
});
export type FraudJourneyApplicationStatusKYCResponse = io.TypeOf<
  typeof FraudJourneyApplicationStatusKYCResponse
>;

export const FraudJourneyApplicationStatusResponse = io.type({
  journeyApplicationStatus: io.union([
    io.literal(JourneyApplicationStatus.Approved),
    io.literal(JourneyApplicationStatus.Denied),
    io.literal(JourneyApplicationStatus.Pending),
    io.literal(JourneyApplicationStatus.Expired),
    io.literal(JourneyApplicationStatus.ApplicationReview),
    io.literal(JourneyApplicationStatus.Error),
    io.literal(JourneyApplicationStatus.Running),
  ]),
});
export type FraudJourneyApplicationStatusResponse = io.TypeOf<
  typeof FraudJourneyApplicationStatusResponse
>;
